import { render, staticRenderFns } from "./rehber.vue?vue&type=template&id=5c3d1a5a"
import script from "./rehber.vue?vue&type=script&lang=js"
export * from "./rehber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports